// src/services/api.js
import axios from 'axios';

const isNative = window.Capacitor && window.Capacitor.isNativePlatform;

const api = axios.create({
  baseURL: 'https://jmew.xyz/aac/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
